export const STRIPE_KEY = "pk_live_51LNmxmHxC80raz6ypSEYDlwU4uYcPKvPn2JleEl4e8PfFk04hxGFdywukKbPQXTxTigSngR0Vwydu309pggypghI00FXSbEuq6";
